import { endpoints } from './endpoints.js';

export const environment = {
  production: false,
  api: 'http://localhost:8000',
  endpoints,
  features: {
    enablePricingChart: false,
  },
};
